import { Box } from '@mui/material';
import { DynamicIcon } from 'src/components';
import { MemoPlanAccordion } from 'src/pages/Settings/memberships/components/plans-tab/plan-accordion';
import type { PlatformSlaFieldState } from 'src/pages/Settings/memberships/components/plans-tab/types';

interface ArchivedPlanItemProps {
  planId: string;
  index: number;
  onRemove: (index: number, planId: string) => void;
  platformSla: PlatformSlaFieldState;
  readOnly: boolean;
}

export const ArchivedPlanItem = ({
  planId,
  index,
  onRemove,
  platformSla,
  readOnly,
}: ArchivedPlanItemProps): React.JSX.Element => (
  <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
    <Box
      aria-hidden
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        alignSelf: 'flex-start',
        py: 1.5,
        px: 0.25,
      }}
    >
      <DynamicIcon name="archive" library="lucide" size={18} sx={{ color: 'text.disabled' }} />
    </Box>
    <Box sx={{ flexGrow: 1, minWidth: 0 }}>
      <MemoPlanAccordion
        index={index}
        planId={planId}
        expanded={false}
        onExpandedChange={() => undefined}
        onRemove={onRemove}
        autoFocusName={false}
        isNew={false}
        platformSla={platformSla}
        readOnly={readOnly}
      />
    </Box>
  </Box>
);
